import React, { createContext, useContext, useState } from "react";

interface GroupDashboardContextType{
  selectedTeamId: String;
  setSelectedTeamId: React.Dispatch<React.SetStateAction<string>>
  selectedTeamType: String;
  setSelectedTeamType: React.Dispatch<React.SetStateAction<string>>
  selectedAddMemberModal: {};
  setSelectedAddMemberModal: React.Dispatch<React.SetStateAction<{}>>
  filtersData: {};
  setFiltersData: React.Dispatch<React.SetStateAction<{}>>
  selectedSeats: {};
  setSelectedSeats: React.Dispatch<React.SetStateAction<{}>>
}

const GroupDashboardContext = createContext<GroupDashboardContextType | null>(null)

const GroupDashboardProvider: React.FC = ({ children }) => {
  const [ selectedTeamId, setSelectedTeamId ] = useState('')
  const [ selectedTeamType, setSelectedTeamType ] = useState('')
  const [selectedAddMemberModal, setSelectedAddMemberModal ] = useState({})
  const [filtersData, setFiltersData ] = useState({})
  const [selectedSeats, setSelectedSeats ] = useState({})

  return(
    <GroupDashboardContext.Provider value={{ 
      selectedTeamId,
      setSelectedTeamId,
      selectedTeamType,
      setSelectedTeamType,
      selectedAddMemberModal,
      setSelectedAddMemberModal,
      filtersData,
      setFiltersData,
      selectedSeats,
      setSelectedSeats
    }}>
      { children }
    </GroupDashboardContext.Provider>
  )
}

const useGroupDashboardContext = (): GroupDashboardContextType => {
  const context = useContext(GroupDashboardContext)
  if( !context ){
    throw new Error('useGroupDashboardContext must be used within a GroupDashboardProvider');
  }
  return context
}

export{
  GroupDashboardProvider,
  useGroupDashboardContext
}
